import {
  isMobile as _isMobile,
  isTablet as _isTablet,
} from "react-device-detect"

export const isMobile = () => _isMobile
export const isTablet = () => _isTablet
